module.exports = "<wow-dynamic-suburb-dialog ng-if=\"$ctrl.shouldDisplayDynamicSuburbDialog\"></wow-dynamic-suburb-dialog>\r\n<wow-express-selected-dialog ng-if=\"::$ctrl.shouldDisplayExpressSelectedDialog\"></wow-express-selected-dialog>\r\n<wow-fulfilment-selector-dialog ng-if=\"$ctrl.shouldDisplayFulfillmentSelectorDialog\"></wow-fulfilment-selector-dialog>\r\n<wow-on-boarding-dialog  ng-if=\"$ctrl.shouldDisplayOnboardingDialog\" on-dismiss=\"$ctrl.closeOnBoardingDialog()\"></wow-on-boarding-dialog>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/notificationpanel/notification-panel.component.html
// module id = 316
// module chunks = 0 2